import api from '../../../api';
import { ResponseSuccess } from '../../../shared/types';

export const getCoreFeaturesCredits = async () => api.get<ResponseSuccess>(`/user/credits`);
